import script from "./FeedbackForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeedbackForm.vue?vue&type=script&lang=ts&setup=true"

import "./FeedbackForm.vue?vue&type=style&index=0&id=6fef3ec3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fef3ec3"]])

export default __exports__